// @ts-check
// Marca as novidades da versão atual como vistas (contrato 08-contrato-novidades.md, seção 4): a sessão muda na hora,
// então o balão e o cartão somem sem esperar a rede; o POST grava a marca da pessoa no core. Na falha o aviso não volta
// nesta sessão e reaparece no próximo carregamento, sem incomodar com erro.
import { api } from './api-client.js';
import { sessionState } from './metadata-store.js';
import { APP_VERSION } from '../../../shared/app-version.js';

export async function markReleaseNotesSeen() {
  const session = /** @type {any} */ (sessionState.value);
  if (session?.releaseNotes) sessionState.value = { ...session, releaseNotes: { ...session.releaseNotes, lastSeenVersion: APP_VERSION } };
  try {
    await api.post('/auth/release-notes/seen', { version: APP_VERSION }, undefined, { skipUnauthorizedRedirect: true });
  } catch (error) {
    console.warn('Não foi possível gravar as novidades como vistas', error);
  }
}
